// src/hooks/useHostedOrdersAndTickets.ts
import useSWR from "swr";
import { fetcher } from "../config/axiosConfig.ts";
import { swrOptions } from "../const.ts";

export interface EventDetailsView {
  idEvent: string;
  eventName: string;
  startDate: string;
  endDate?: string | null;
  startTime: string;
  endTime?: string | null;
  duration?: number | null;
  coverPhoto: string;
  eventType: "PUBLIC" | "PRIVATE" | string;
  ticketType: "FREE" | "PAID" | "OTHER";
  ticketCost: number;
  attendanceTypeEnum: "ONLINE" | "OFFLINE";
  processStatus: string;
  minAttendees: number;
  maxAttendees: number;
  description?: string | null;
  address?: string | null;
  mobileNumber?: string | null;
  viewCount: string;
  listOfCategories: Array<{
    name: string;
    keyword: string;
    title?: string | null;
    body?: string | null;
  }>;
  attendeesPermission: boolean;
}

export interface OrderView {
  id: string;
  paymentStatus: string;
  ticketType: "FREE" | "PAID" | "OTHER";
  orderDate: string;
  transactionId: string;
  paymentSource: string;
}

export interface OrderInfoView {
  id: string;
  name: string;
  surname: string;
  email: string;
  qrCode: string;
  price: number;
  startDate: string;
  startTime: string;
  idEventTicketInfo: string;
  idEventTicketOrder: string;
  contact_number: string;
  qrCheckInCount: number;
  checkInDateTime?: string | null;
  checkInDates?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface OrdersWithInfosView {
  orderView: OrderView;
  orderInfoView: OrderInfoView[];
}

export interface HostedOrdersAndTicketsResponse {
  code: number;
  message: string;
  body: {
    eventDetailsView: EventDetailsView;
    ordersWithInfosView: OrdersWithInfosView[];
  };
}

export function useHostedOrdersAndTickets(
    eventId: string,
    page: number = 1,
    size: number = 2000
) {
  const url = `event-data?eventId=${encodeURIComponent(
      eventId
  )}&size=${size}&page=${page}`;

  const { data, error, isLoading } = useSWR<HostedOrdersAndTicketsResponse>(
      url,
      fetcher,
      swrOptions
  );

  return {
    eventDetails: data?.body.eventDetailsView ?? null,
    ordersWithInfos: data?.body.ordersWithInfosView ?? [],
    isLoading,
    error,
  };
}
